import { ExtractedBinding } from './extraction';

export type VegaRadioControlState = { type: 'radio'; value: string };
type VegaControlState = VegaRadioControlState;
export type VegaState = Partial<Record<string, VegaControlState>>;

type VegaRadioAction = {
  type: 'onChangeRadio';
  payload: { name: string; value: string };
};
export type VegaControlAction =
  | VegaRadioAction
  | { type: 'reset'; payload: VegaState };

export const vegaControlReducer = (
  state: VegaState,
  action: VegaControlAction
): VegaState => {
  switch (action.type) {
    case 'reset':
      return action.payload;
    case 'onChangeRadio':
      return {
        ...state,
        [action.payload.name]: { type: 'radio', value: action.payload.value },
      };
    default:
      return state;
  }
};

export const getInitialControlState = (bindings: ExtractedBinding[]) => {
  const state: VegaState = {};

  for (const binding of bindings) {
    switch (binding.bindingType) {
      case 'radio':
        state[binding.signalName] = {
          type: 'radio',
          value: binding.initialOption,
        };
    }
  }

  return state;
};
